import ArtPage from "./views/ArtPage.vue";
import HomePage from "./views/HomePage.vue";
import LayoutBase from "./layouts/LayoutBase.vue";
import VueRouter from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: LayoutBase,
    children: [
      {
        path: "/",
        component: HomePage,
      },
      { path: "/art/:id", component: ArtPage },
      { path: "/art/:id/preview", component: ArtPage },
      // The upload wizard is a modal over the site, not a page of its own, so
      // /add renders the same HomePage as /: someone arriving cold on the link
      // from WordPress sees the map with the wizard over it, and closing it
      // reveals a site rather than a blank page. LayoutBase reads the wizard's
      // open state straight off this path (features/arts/wizard-route.js).
      //
      // Reusing the HomePage component is also what keeps opening the wizard
      // cheap: router-view sets no key, so Vue patches the same instance
      // rather than remounting the map. Mirrored by a Rails route in
      // config/routes.rb, without which a refresh here 404s.
      { path: "/add", component: HomePage },
    ],
  },
];

export const router = new VueRouter({
  mode: "history",
  routes,
});
